export const IconRefer = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.6396 2.80588L10.7828 15.6101L8.69502 11.5034C8.65722 11.429 8.61719 11.356 8.57501 11.2845L11.7563 8.10322C12.1468 7.7127 12.1468 7.07953 11.7563 6.68901C11.3658 6.29848 10.7326 6.29848 10.3421 6.68901L7.16076 9.87032C7.08929 9.82818 7.01636 9.78819 6.94206 9.75042L2.83535 7.66265L15.6396 2.80588ZM14.9303 0.935884C16.5424 0.324379 18.1211 1.90304 17.5096 3.51519L12.6528 16.3194C12.037 17.9429 9.78685 18.0643 8.99995 16.5164L6.91219 12.4097C6.72022 12.0321 6.41331 11.7252 6.03571 11.5333L1.92899 9.44549C0.381145 8.65859 0.502526 6.40847 2.12604 5.79265L14.9303 0.935884Z"
                fill="currentColor"
            />
        </svg>
    );
};
